$(document).ready(function($) {
    // TODO: TOC disabled on mobile; run only when viewport >= 1200 – no heading IDs on mobile
    if (window.innerWidth >= 1200) {
        // Table of Content START – add ids so TOC anchor links work (match get_toc depth: h2 only)
        let toc_id = 1;
        $('.article__content.text-wrap h2').each(function () {
            $(this).attr('id', 'h' + toc_id);
            toc_id++;
        });
        // Table of Content END
    } else {
        // TODO: TOC HTML removed on mobile; element .article__contents
        $('.article__contents').remove();
    }

    let currentIndex = 0;
    const previews = document.querySelectorAll(".preview-image");
    const slides = document.querySelectorAll(".slide");

    previews.forEach((preview, index) => {
        preview.addEventListener("click", () => {
            currentIndex = index;
            updateSlider();
        });
    });

    function showHidePostNav() {
        /*
         * Article contents toggler manipulation TODO:
         * Both files manipulate #article-contents-toggler:
         * article-contents.js: Extensive handling for mobile overlay, share buttons, etc.
         * insights-articles.js: Adds/removes classes in showHidePostNav()
         *
         *Impact: Potential conflicts in class toggling and behavior.
        */
        if (window.innerWidth < 1200) {
            $('#article-contents-toggler, #article-contents-toggler-mobile').removeClass('article__contents-toggler--hidden');
            $('.article__contents-inner').addClass('article__contents-inner--mobile');
        } else {
            $('#article-contents-toggler, #article-contents-toggler-mobile').addClass('article__contents-toggler--hidden');
            $('.article__contents-inner').removeClass('article__contents-inner--mobile active');
        }
    }
    // TODO: TOC disabled on mobile; toggler/contents visibility only when viewport >= 1200
    if (window.innerWidth >= 1200) {
        showHidePostNav();
    }

    function sliderVacancies() {
        if ($('.career__vacancy-item').length > 1) {
            let sliderVacanciesEl = $('.js-article-career__vacancies-items');
            if (!$.fn.slick) {
                if (typeof window.mobidevOnSlickReady === 'function') {
                    window.mobidevOnSlickReady(sliderVacancies);
                }
                return;
            }

            if (window.innerWidth < 1201 && window.innerWidth > 640) {
                sliderVacanciesEl.not('.slick-initialized').slick({
                    infinite: false,
                    speed: 300,
                    slidesToShow: 1.6,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 1.06
                            }
                        }
                    ]
                });
            } else {
                if (sliderVacanciesEl.length) {
                    if (sliderVacanciesEl.hasClass('slick-initialized')) {
                        sliderVacanciesEl.slick('unslick');
                    }
                }
            }
        }
    }
    sliderVacancies();

    function updateSlider() {
        slides.forEach((slide, index) => {
            if (index === currentIndex) {
                slide.style.display = "block";
                previews[index].classList.add("active");
            } else {
                slide.style.display = "none";
                previews[index].classList.remove("active");
            }
        });
    }
    updateSlider();

    let scrollStart = 0,
        scrollCurrent = scrollStart,
        scrollCurrentNext = scrollCurrent

    if ($(this).width() < 1200) {
        toggleMobileNav(true)
    }
    $(window).on('resize orientationchange scroll', function () {
        scrollCurrent = $(window).scrollTop()
        if ($(this).width() < 1201) {
            toggleMobileNav(true)
            if (scrollCurrentNext > scrollCurrent) {
                toggleMobileNav(true)
                scrollCurrent = $(window).scrollTop()
                scrollCurrentNext = scrollCurrent
            } else if (scrollCurrent > scrollStart) {
                toggleMobileNav(false)
                scrollCurrent = $(window).scrollTop()
                scrollCurrentNext = scrollCurrent
            }
        } else {
            toggleMobileNav(false)
        }

        // TODO: TOC disabled on mobile; showHidePostNav only when viewport >= 1200
        if (window.innerWidth >= 1200) {
            showHidePostNav();
        }
    });

    /* Mobile navigation handling TODO:
     * insights-articles.js: toggleMobileNav() function toggles cookie notice and mobile nav
     * article-contents.js: Handles mobile contents overlay and positioning
     *
     * Impact: Both may try to control mobile UI elements.
    */
    function toggleMobileNav(isShow) {
        if (isShow) {
            $('#cookie-notice').addClass('active')
            $('.article-mobile-navigation').addClass('active');
        } else {
            $('#cookie-notice').removeClass('active')
            $('.article-mobile-navigation').removeClass('active');
        }
    }

    // TODO: TOC scroll spy and link clicks disabled on mobile; run only when viewport >= 1200
    if (window.innerWidth >= 1200) {
        // Variables
        const $links = $(".article__contents .natural a");
        const $sections = getSections($links);
        const $hashLinks = $('.article__contents a[href^="#"]:not([href="#"])');

        // Functions
        function getSections($links) {
            return $(
                $links
                    .map((i, el) => $(el).attr("href"))
                    .toArray()
                    .filter((href) => href.charAt(0) === "#")
                    .join(",")
            );
        }

        function activateLink($sections, $links) {
            const yPosition = $(window).scrollTop();
            for (let i = $sections.length - 1; i >= 0; i -= 1) {
                const $section = $sections.eq(i);

                if (yPosition + 220 >= $section.offset().top) {

                    $links
                        .removeClass("active")
                        .filter(`[href="#${$section.attr("id")}"]`)
                        .addClass("active");
                    return;
                }
            }
        }

        function onScrollHandler() {
            activateLink($sections, $links);
        }

        function onClickHandler(e) {
            const $header = $("header");
            const headerHeight = $header.length ? $header.outerHeight() : 0;

            $('a[href^="#"]').on("click", function (e) {
                const href = $(this).attr("href");

                if (!href || href === "#") return;

                const targetId = href.substring(1);
                const $target = $("#" + targetId);

                if (!$target.length) return;

                e.preventDefault();

                const scrollTo = $target.offset().top - headerHeight;

                $("html, body").animate({
                    scrollTop: scrollTo
                }, 0);
            });
        }

        // Events
        $(window).on("scroll", onScrollHandler);
        $hashLinks.on("click", onClickHandler);

        // Body
        activateLink($sections, $links);
    }

    // $('.article__terms a').on('click', function () {
    //     let newUrl
    //     if ($('body').is('.single-insights')) {
    //         newUrl = window.location.origin + '/trends-and-insights'
    //     } else {
    //         newUrl = window.location.origin + '/mobidev-life?filter=' + $(this).attr('data-term');
    //     }
    //     window.location.href = newUrl;
    // });
});
